// Shared currency symbol mapping for the app's 3 supported quotation currencies.
export const CURRENCY_SYMBOLS = { USD: "$", CAD: "C$", CNY: "¥" };

export function getCurrencySymbol(currency) {
  return CURRENCY_SYMBOLS[currency] || "$";
}

export function formatCurrency(value, currency) {
  if (value == null || Number.isNaN(Number(value))) return "-";
  return `${getCurrencySymbol(currency)}${Number(value).toFixed(2)}`;
}
